export var eventId = function eventId(config) {
  return {
    'event:id': config.key
  };
};